
import { signOut } from "firebase/auth";
import {auth} from '../utils/FireBase';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Link } from "react-router-dom";
const Profile = () =>{
    const navigate = useNavigate()
    const userData = useSelector(store=>store.user)
    console.log(userData);

    useEffect(()=>{
      if(!userData){
        navigate('/')
      }
    },[userData])
    
const handleClick =()=>{
    signOut(auth).then(() => {
        dispatch(removeUser());
        navigate('/');
      }).catch((error) => {
        
      });
      
}
    return(
        <>
        <button
            onClick={handleClick}
            className="m-6 margin-left border p-2 border-red-400 rounded-md font-bold text-md absolute right-0"
          >
            LOGOUT
          </button>
        <div className="min-h-[85vh] flex flex-col items-center justify-center">
                  <div className="font-bold text-3xl" style={{ color: "#3D4152" }}>
                    Page Under Construction
                  </div>
                  <div
                    className="mt-2 mb-4 text-base flex flex-col"
                    style={{ color: "#686B78" }}
                  >
                    <span> Sorry! This should not have happened.</span>
                    <span className="text-center">Please Come again later.</span>
                  </div>
            
                  <Link
                    to="/"
                    style={{ backgroundColor: "#FC8019" }}
                    className="text-white p-2 text-base font-bold rounded"
                  >
                    HOME
                  </Link>
                </div>
            
        
       
        </>
    )
}
export default Profile;
